import React from 'react';
import PropTypes from 'prop-types';

function TimeLeft(props) {
    const {
        className = '',
        isTimeLeftBelowWarningLimit,
        timeLeftText,
        icon,
        ...otherProps
    } = props;

    if (!timeLeftText) {
        return null;
    }

    return (
        <span
            data-test-time-left
            className={`${
                isTimeLeftBelowWarningLimit ? 'text-danger' : ''
            } ${className}`}
            {...otherProps}>
            {icon}
            {timeLeftText}
        </span>
    );
}

TimeLeft.propTypes = {
    timeLeftText: PropTypes.string.isRequired,
    isTimeLeftBelowWarningLimit: PropTypes.bool.isRequired
};

export default TimeLeft;
